module.exports = __webpack_public_path__ + "img/logo2.dc3be392.png";